import { Observable } from 'rxjs';
import { ComponentDataSourceService } from '../../../component-data-source/component-data-source.service';
import { environment } from '../../../../environment/environment';

export const deleteAdvisory = (dataDestService: any, componentDataSourceService: ComponentDataSourceService) => {
  return (adviId: number): Observable<any> => {
    
    return dataDestService.http.delete(
      `${environment.apiUrl}/advi/${adviId}`
    );
  };
};
